import {theme as base} from "@chakra-ui/react";

const fonts = {
    heading: `Poppins, ${base.fonts?.heading}`,
    body: `Poppins, ${base.fonts?.body}`,
};

export default fonts;